/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit3_TInputs */

const en_diff_pit3_t = /** @type {(inputs: Diff_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identical values short circuit, including identical nulls`)
};

const ko_diff_pit3_t = /** @type {(inputs: Diff_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동일한 값은 즉시 통과되며, 동일한 null도 그렇습니다`)
};

const ja_diff_pit3_t = /** @type {(inputs: Diff_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同一の値は即座に通過し、同一の null もそうです`)
};

/**
* | output |
* | --- |
* | "Identical values short circuit, including identical nulls" |
*
* @param {Diff_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit3_t = /** @type {((inputs?: Diff_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit3_t(inputs)
	if (locale === "ko") return ko_diff_pit3_t(inputs)
	return ja_diff_pit3_t(inputs)
});